import React from 'react';
import b_ from 'b_';

const b = b_.with('audience-settings');

interface Props {
    labels: Array<string>;
}

export default function TargetingTabsPreview({labels}: Props) {
    return (
        <div className={b('targeting-labels')}>
            {labels.map((label, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className={b('targeting-label')} key={index}>
                    {label}
                </div>
            ))}
        </div>
    );
}
